import { jsx as _jsx } from "react/jsx-runtime";
export function SetupLayout({ children }) {
    return (_jsx("div", { className: "min-h-screen bg-duvi-bg flex justify-center px-6 pt-[150px]", children: _jsx("div", { className: "w-full max-w-[480px] h-fit bg-duvi-surface border border-duvi-border rounded-[8px] p-8", style: { boxShadow: "var(--shadow-card)" }, children: children }) }));
}
//# sourceMappingURL=SetupLayout.js.map